module.exports = __webpack_public_path__ + "img/0Q3A2940_L_WoodMatted_MockedUp.83338c4b.jpg";